module.exports = __webpack_public_path__ + "img/UTPIUT.a6a33d07.png";